import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

export default {
  data() {
    return {
      items: [
        {
          id: 1,
          text: 'The most exciting engine in terms of political opinion',
          author: 'James Carville, Political Pundit',
        },
      ],
      swiperModules: [Autoplay],
      swiperOptions: {
        autoplay: { enabled: true, delay: 3000 },
        direction: 'horizontal',
      },
    };
  },
  components: {
    swiper: Swiper,
    swiperSlide: SwiperSlide,
  },
};
